import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import LazyImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./related-search-product-images.css";

function RelatedSearchProductImages({ images }) {
    return (
        <div className={styles.relatedSearchImages}>
            {images &&
                images.map((image) => {
                    return (
                        <LazyImage
                            key={image.url}
                            src={image.url}
                            alt={image.alt_text}
                            className={classnames(styles.relatedSearchImage)}
                            width={128}
                            height={160}
                        />
                    );
                })}
        </div>
    );
}

RelatedSearchProductImages.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            url: PropTypes.string.isRequired,
            alt_text: PropTypes.string,
        })
    ).isRequired,
};

export default RelatedSearchProductImages;
